import { styled } from "@mui/system";

export const OptionalLabelText = styled("span")(({ theme }) => ({
  color: theme.palette.grey[700],
  fontStyle: "italic",
}));
